import config from '../../infrastructure/Config';

export interface AnalyticsEnvironmentConfig {
  enabled: boolean;
  debug: boolean;
  apiKey: string;
  trackPageViews: boolean;
  trackUserActions: boolean;
  trackErrors: boolean;
  appType: 'business' | 'student';
}

export const getAnalyticsConfig = (appType: 'business' | 'student' = 'business'): AnalyticsEnvironmentConfig => {
  const isDev =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('dev');

  const apiKey = config.analytics?.posthog?.apiKey || '';

  return {
    enabled: config.analytics?.enabled !== false && !!apiKey,
    debug: isDev && config.analytics?.debug !== false,
    apiKey,
    trackPageViews: config.analytics?.events?.pageViews !== false,
    trackUserActions: config.analytics?.events?.userActions !== false,
    trackErrors: config.analytics?.events?.errors !== false,
    appType,
  };
};

export const logAnalyticsConfig = (appType: 'business' | 'student' = 'business') => {
  const isDev =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('dev');

  if (!isDev) return;

  const analyticsConfig = getAnalyticsConfig(appType);
  console.log(`📊 Analytics configuration (${appType}):`, {
    enabled: analyticsConfig.enabled,
    debug: analyticsConfig.debug,
    apiKey: analyticsConfig.apiKey ? `${analyticsConfig.apiKey.substring(0, 8)}...` : 'Not set',
    environment: 'development',
    hostname: window.location.hostname,
    appType: analyticsConfig.appType,
    trackPageViews: analyticsConfig.trackPageViews,
    trackUserActions: analyticsConfig.trackUserActions,
    trackErrors: analyticsConfig.trackErrors,
  });
};
